// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;I will declare that your love is established for ever;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;you have set your faithfulness as firm as the heavens.<br> </p> </div></div>";
// Exports
module.exports = code;